<template>
  <span class="metadata-display">
    <span v-if="topicsDisplayList" class="mr-1">
      <span>
        <span class="application-heading">Events:</span> {{ topicsDisplayList }}
      </span>
    </span>
    <span v-if="influenceDisplayList" class="mr-1">
      <span>
        <span class="application-heading">Influences:</span>
        {{ influenceDisplayList }}
      </span>
    </span>
    <div v-if="lineBreaks"></div>
    <span
      v-if="isSentimentFeatureUnlocked && typeof sentiment === 'number'"
      class="pr-1"
    >
      <span>
        <span class="application-heading">Sentiment:</span> {{ textSentiment }}
      </span>
    </span>
    <span
      v-if="isLiveSearchEventsSeverityUnlocked && displaySeverity"
      class="pr-1"
    >
      <span>
        <span class="application-heading">Severity:</span> {{ displaySeverity }}
      </span>
    </span>
    <span
      v-if="isLiveSearchEventsOriginalLanguageUnlocked && originalLanguage"
      class="pr-1"
    >
      <span>
        <span class="application-heading">Original Language:</span>
        {{ originalLanguage }}
      </span>
    </span>
    <span v-if="isLiveSearchAnalysisUnlocked && analysisInfo && !verifiedEvent">
      <div v-if="analysisInfo.countries" class="analysis-text">
        <span class="application-heading">Countries:</span>
        <DetailsListItemClickable :content="analysisInfo.countries" />
      </div>
      <div v-if="analysisInfo.risks" class="analysis-text">
        <span class="application-heading">Risks:</span> {{ analysisInfo.risks }}
      </div>
      <div v-if="analysisInfo.published" class="analysis-text">
        <span class="application-heading">Published:</span>
        <span v-html="analysisInfo.published" class="ml-1"></span>
      </div>
      <div v-if="analysisInfo.tags" class="analysis-text">
        <span class="application-heading">Tags:</span>
        <span v-html="analysisInfo.tags" class="ml-1"></span>
      </div>
    </span>
  </span>
</template>

<script>
export default {
  name: "DetailsListItemExtras",
  props: {
    sentiment: {
      type: Number,
      required: false,
    },
    topicsDisplayList: {
      type: String,
      required: false,
    },
    influenceDisplayList: {
      type: String,
      required: false,
    },
    lineBreaks: {
      type: Boolean,
      default: false,
    },
    severity: {
      type: Number,
    },
    analysisInfo: {
      type: Object,
    },
    verifiedEvent: {
      type: Boolean,
    },
    originalLanguage: {
      type: String,
      required: false,
    },
  },
  components: {
    DetailsListItemClickable: () =>
      import("@/components/common/details/DetailsListItemClickable"),
  },
  computed: {
    isSentimentFeatureUnlocked() {
      return this.featureUnlocked("sentiment-on-articles");
    },
    isLiveSearchEventsFilterV2Unlocked() {
      return this.featureUnlocked("livesearch-filter-events-v2");
    },
    isLiveSearchAnalysisUnlocked() {
      return this.featureUnlocked("livesearch-filter-analysis");
    },
    isLiveSearchEventsSeverityUnlocked() {
      return this.featureUnlocked("livesearch-events-severity");
    },
    color() {
      if (typeof this.sentiment === "number") {
        if (this.sentiment > 1) {
          return "#00A100";
        } else if (this.sentiment < -1) {
          return "#F44436";
        }
      }
      return "#7B7B7B";
    },
    textSentiment() {
      if (typeof this.sentiment === "number") {
        if (this.sentiment > 1) {
          return "Positive";
        } else if (this.sentiment < -1) {
          return "Negative";
        }
        return "Neutral";
      }
      return null;
    },
    displaySeverity() {
      if (!this.verifiedEvent && this.severity) {
        return this.severity > 5 ? "6-10" : "0-5";
      } else {
        return this.severity;
      }
    },
    isLiveSearchEventsOriginalLanguageUnlocked() {
      return this.featureUnlocked("livesearch-events-original-language");
    },
  },
};
</script>

<style scoped>
.metadata-display {
  font-size: 10px;
  line-height: 1;
}
.analysis-text {
  line-height: 16px;
}
</style>
